import LockIcon from './icons/LockIcon';
import { LoadingDots } from './LoadingDots';
export function FormSubmit(props) {
	const {
		cartData,
		handleSubmit,
		total,
		processingCheckout,
		disablePaymentBtn,
		isLoading,
	} = props;

	return (
		<>
			<div className="wp-checkout-form-submit-btn-border">
				<button
					className="wp-checkout-font-lg wp-checkout-form-submit-btn"
					onClick={handleSubmit}
					disabled={disablePaymentBtn}
				>
					<span className="line-height-0">
						<LockIcon />
					</span>
					{isLoading && <LoadingDots />}
					{!isLoading && disablePaymentBtn && (
						<span>Processing...</span>
					)}
					{!isLoading && !disablePaymentBtn && (
						<span>Pay ${cartData?.total?.toFixed(2)}</span>
					)}
				</button>
			</div>

			<p className="wp-checkout-font-sm money-back-guarantee">
				<span className="line-height-0">
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clipPath="url(#clip0_941_509)">
							<path
								d="M9.99719 1.66797L10.0955 1.6738L10.1447 1.68047L10.1955 1.6913L10.288 1.71964C10.3519 1.74319 10.4126 1.77454 10.4689 1.81297L10.5555 1.8813L10.768 2.06297C12.4491 3.45927 14.5737 4.20905 16.7589 4.17714L17.0439 4.1688C17.2302 4.1603 17.414 4.21456 17.5658 4.32288C17.7177 4.43121 17.8288 4.58735 17.8814 4.7663C18.2909 6.15928 18.4162 7.62037 18.2498 9.06273C18.0835 10.5051 17.6289 11.8993 16.9131 13.1625C16.1973 14.4258 15.2349 15.5322 14.0831 16.4161C12.9312 17.3 11.6134 17.9434 10.208 18.308C10.0708 18.3435 9.92686 18.3435 9.78969 18.308C8.3842 17.9435 7.06633 17.3002 5.91438 16.4163C4.76244 15.5324 3.79992 14.426 3.08404 13.1628C2.36816 11.8995 1.91352 10.5053 1.74714 9.06289C1.58076 7.62048 1.70604 6.15934 2.11552 4.7663C2.16811 4.58735 2.27922 4.43121 2.43106 4.32288C2.5829 4.21456 2.76669 4.1603 2.95302 4.1688C5.23424 4.27308 7.47224 3.52213 9.22886 2.06297L9.44802 1.87547L9.52802 1.81297C9.58423 1.77454 9.64497 1.74319 9.70886 1.71964L9.80219 1.6913C9.83485 1.68341 9.86797 1.67757 9.90136 1.6738L9.99719 1.66797ZM13.0889 7.74547C13.0115 7.66799 12.9196 7.60652 12.8184 7.56459C12.7172 7.52265 12.6088 7.50106 12.4993 7.50106C12.3898 7.50106 12.2813 7.52265 12.1802 7.56459C12.079 7.60652 11.9871 7.66799 11.9097 7.74547L9.16552 10.4888L8.08802 9.41214L8.00969 9.34297C7.8422 9.21346 7.63169 9.15256 7.42092 9.17264C7.21015 9.19271 7.01492 9.29227 6.87489 9.45107C6.73487 9.60987 6.66054 9.81602 6.667 10.0276C6.67346 10.2393 6.76023 10.4405 6.90969 10.5905L8.57636 12.2571L8.65469 12.3263C8.81503 12.4507 9.01523 12.5123 9.21776 12.4995C9.42028 12.4868 9.61119 12.4006 9.75469 12.2571L13.088 8.9238L13.1572 8.84547C13.2816 8.68513 13.3432 8.48492 13.3304 8.2824C13.3177 8.07988 13.2315 7.88896 13.088 7.74547H13.0889Z"
								fill="#8F949B"
							/>
						</g>
						<defs>
							<clipPath id="clip0_941_509">
								<rect
									width="20"
									height="20"
									fill="white"
								/>
							</clipPath>
						</defs>
					</svg>
				</span>
				<span>
					<span className="highlight-text">
						14 DAYS MONEY BACK GUARANTEE:
					</span>{' '}
					if you are not 100% satisfied with our products, you will
					receive a 100% refund.
				</span>
			</p>
		</>
	);
}
